export const classes = {
  timeoutDialogButtons: {
    display: 'inline-block',
    textAlign: 'right',
    width: '100%',
  },
}
